/**
 * A planilha como no da tela.
 *
 * Envolucro fino sobre o componente copiado: o renderer recebe as tres entradas
 * de sempre e passa adiante o que a planilha entende. O tipo continua no
 * catalogo porque ha telas gravadas com ele — a apuracao que diria o contrario
 * nunca foi feita, e migracao sem perda vem antes de simplificar o catalogo.
 */
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { ScreenNode, SpreadsheetProps } from '../../model/node-props';
import { NodeRenderer, RenderMode } from '../../render/node-renderer';
import { BuilderSpreadsheetComponent } from './spreadsheet.component';

@Component({
  selector: 'tem-spreadsheet-renderer',
  standalone: true,
  imports: [BuilderSpreadsheetComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<tem-spreadsheet [props]="props()" />`
})
export class SpreadsheetRenderer implements NodeRenderer<'spreadsheet'> {

  readonly node = input.required<ScreenNode<'spreadsheet'>>();
  readonly form = input<FormGroup | null>(null);
  readonly mode = input<RenderMode>('view');

  readonly props = computed<SpreadsheetProps>(() => this.node().props);
}
